import { isNullOrEmpty } from "./isNullOrEmpty";
import { obterQueryString } from "./obterQueryString";

export function obterOrigem() {
    let origem = document.referrer.split('/')[2];
    if (isNullOrEmpty(origem)) {
        origem = obterQueryString().source;
    }
    if (isNullOrEmpty(origem)) {
        origem = obterQueryString()['utm_source'];
    }
    return origem;
}